import Admonition from './Admonition';

export default Admonition;
